export default "__VITE_ASSET__BkEYUsYM__"